/*
 * @Author: your name
 * @Date: 2022-03-03 12:56:45
 * @LastEditTime: 2022-05-08 22:48:39
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\api\api-file.js
 */
import apiRequest from '../utils/api-request'
import config from '../common/config'
const baseUrl = config.baseUrl
export class uploadClient
{
	/* 
	 * 文件上传
	 */
	upload(file) { 
		return apiRequest.upload(baseUrl + '/together-boot/sys/common/upload', file)
	}

	/* 
	 * 文件上传（包含其它参数）
	 */
	upload_1(formData) { 
		return apiRequest.upload(baseUrl + '/together-boot/sys/common/upload', null, formData)
	}
}


export default
{
	uploadClient: new uploadClient(),
}